import React from 'react';
import {Tabs} from 'antd';
import type {TabsProps} from 'antd';
type PlacementTestsHeaderProps = {
  items: TabsProps['items'];
  onChange: (key: string) => void;
};
export const PlacementTestsHeader = ({
  items,
  onChange,
}: PlacementTestsHeaderProps) => {
  return (
    <div style={{marginLeft: 16}}>
      <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </div>
  );
};
